import { render, staticRenderFns } from "./PhoneInfo.vue?vue&type=template&id=56da4d1b&"
import script from "./PhoneInfo.vue?vue&type=script&lang=js&"
export * from "./PhoneInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports